import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, IconButton, Typography } from '~/UIKit';
import { useProductToursStyles } from './productTours.styles';
import ModalComponent from '../Modal/Modal.component';
import { CloseIcon } from '../Icons/CloseIcon';

interface IProps {
  icon: ReactElement;
  title: string;
  nextStep?: {
    onClick: () => void;
    actionName: string;
  };
  onClose: () => void;
  children?: ReactElement;
  show?: boolean;
  isGoingBackToTheDashboard?: boolean;
}

export const ProductTours = ({
  icon,
  onClose,
  title,
  children,
  nextStep,
  show = true,
  isGoingBackToTheDashboard = false,
}: IProps) => {
  const { t } = useTranslation();
  const { classes } = useProductToursStyles();

  if (!show) {
    return null;
  }

  return (
    <>
      <ModalComponent open={show} onClose={() => {}}>
        <div className={classes.container}>
          <div className={classes.icon}>{icon}</div>
          <div className={classes.title}>{title}</div>
          <IconButton className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
          <Typography className={classes.description}>{children}</Typography>
          {nextStep ? (
            <div className={classes.buttonContainer}>
              <Button fullWidth variant="outlined" size="large" onClick={onClose}>
                {nextStep.actionName || t('onboardingServices.close')}
              </Button>
              <Button
                fullWidth
                size="large"
                variant="contained"
                onClick={nextStep.onClick}
                className={classes.button}
              >
                {isGoingBackToTheDashboard ? t('tours.backToTheDashboard') : t('app.nextStep')}
              </Button>
            </div>
          ) : (
            <Button fullWidth variant="contained" size="large" onClick={onClose}>
              {t('app.continue')}
            </Button>
          )}
        </div>
      </ModalComponent>
      <div className={classes.overlay} onClick={onClose} />
    </>
  );
};
